import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageSquare, X, MessagesSquare } from "lucide-react";

const PHONE = "+19793379282";
const SMS_BODY = encodeURIComponent(
  "Hi 7 Star Limo! I'd like a quote for a ride.\nPickup:\nDrop-off:\nDate & time:\nPassengers:\nVehicle (Sedan/SUV):"
);

export default function FloatingContact() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
      <AnimatePresence>
        {open && (
          <>
            <motion.a
              key="text"
              initial={{ opacity: 0, y: 12, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 12, scale: 0.9 }}
              transition={{ duration: 0.2 }}
              href={`sms:${PHONE}?&body=${SMS_BODY}`}
              data-testid="text-quote-btn"
              className="flex items-center gap-2 bg-primary text-primary-foreground pl-4 pr-5 py-3 shadow-[0_8px_24px_rgba(0,0,0,0.5)] hover:bg-primary/90 transition-colors uppercase text-xs tracking-wide font-medium"
            >
              <MessageSquare size={17} /> Text for a Quote
            </motion.a>
            <motion.a
              key="call"
              initial={{ opacity: 0, y: 12, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 12, scale: 0.9 }}
              transition={{ duration: 0.2, delay: 0.05 }}
              href={`tel:${PHONE}`}
              data-testid="call-quote-btn"
              className="flex items-center gap-2 bg-[#1A1A1A] border border-primary/40 text-primary pl-4 pr-5 py-3 shadow-[0_8px_24px_rgba(0,0,0,0.5)] hover:bg-[#222] transition-colors uppercase text-xs tracking-wide font-medium"
            >
              <Phone size={17} /> Call 979-337-9282
            </motion.a>
          </>
        )}
      </AnimatePresence>

      <motion.button
        onClick={() => setOpen((o) => !o)}
        data-testid="floating-contact-toggle"
        whileTap={{ scale: 0.92 }}
        className="relative h-16 w-16 rounded-full bg-primary text-primary-foreground shadow-[0_8px_28px_rgba(212,175,55,0.45)] flex items-center justify-center hover:bg-primary/90 transition-colors"
        aria-label="Contact us"
      >
        {!open && <span className="absolute inset-0 rounded-full bg-primary/40 animate-ping" />}
        {open ? <X size={26} className="relative" /> : <MessagesSquare size={26} className="relative" />}
      </motion.button>
    </div>
  );
}
